import { z } from "zod";

import { type Resolve } from "@/utils/types";

import { dateSchema } from "./utils";

const metricsSchema = z.object({
  impression: z.string().catch(""),
  reason: z.string().catch(""),
  expires_at: dateSchema,
});

type Metrics = Resolve<z.infer<typeof metricsSchema>>;

export { metricsSchema, type Metrics };
